<h5 mat-dialog-title *ngIf="data.type == 'account'">{{'title.money_transfer_cts_to_sms' | translate}}
  <button type="button" class="close" aria-label="Close" cdkFocusInitial (click)="cancel()">
    <span aria-hidden="true">&times;</span>
  </button>
</h5>
<h5 mat-dialog-title *ngIf="data.type == 'sms'">{{'title.money_transfer_sms_to_cts' | translate}}
  <button type="button" class="close" aria-label="Close" cdkFocusInitial (click)="cancel()">
    <span aria-hidden="true">&times;</span>
  </button>
</h5>
<mat-divider style="padding-bottom: 1rem;"></mat-divider>
<form name="form" #f="ngForm" (ngSubmit)="f.form.valid && (data.type == 'sms' ? moneyTransferCts() : moneyTransfer()) " appFocusFirstElement>
  <!-- content account to sms -->
  <mat-dialog-content *ngIf="data.type == 'sms'">
    <p style="margin-bottom: 16px"> {{textMaxMoneySMS()}} </p>
    <mat-form-field class="mat-full-width">
      <input matInput name="reason" id="reason" rows="3" [(ngModel)]="document.reason" #reason="ngModel"
             [ngClass]="{ 'is-invalid': f.submitted && reason.invalid }" [placeholder]="'form.money' | translate" (keypress)="numberOnly($event)"
             (paste)="onPasteNumber($event)" (blur)="onBlurEvent($event)"
      />
    </mat-form-field>
    <span class="text-error text-danger" *ngIf="validationMaxMoney(document.reason, data.num, data.configMoney)">
      {{textValidator()}}
    </span>
  </mat-dialog-content>

  <!-- content sms to account  -->
  <mat-dialog-content *ngIf="data.type == 'account'">
    <p style="margin-bottom: 16px">{{textMaxMoneyTSA()}}</p>
    <mat-form-field class="mat-full-width">
      <input matInput name="reason" id="reason" rows="3" [(ngModel)]="document.reason" #reason="ngModel"
             [ngClass]="{ 'is-invalid': f.submitted && reason.invalid }" [placeholder]="'form.money' | translate" (keypress)="numberOnly($event)"
             (paste)="onPasteNumber($event)" (blur)="onBlurEvent($event)"
      />
    </mat-form-field>
    <span class="text-error text-danger" *ngIf="validationMaxMoney(document.reason, data.num, data.configMoney)">
      {{textValidator()}}
    </span>
  </mat-dialog-content>
  <mat-dialog-actions align="center" class="pt-4 pb-3">
    <button mat-stroked-button color="primary" type="button" (click)="cancel()" class="mr-2">
      <mat-icon class="mr-0">cancel</mat-icon>{{ "button.cancel" | translate }}
    </button>
    <button [disabled]="validationLengthMoney(document.reason, data.num) || validationMaxMoney(document.reason, data.num, data.configMoney) || document.reason.length === 0" mat-raised-button color="primary" type="submit" class="ml-2">
      <mat-icon class="mr-0">save</mat-icon>{{ "button.save" | translate }}
    </button>
  </mat-dialog-actions>
</form>
